import React, { Component } from 'react';
import { Layout, Menu, Icon } from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import { routesAdmin } from 'routes/Routes';
import {
  DISABLE_SEND_SMS_EMAIL_HALL_TICKET_LINK,
  DISABLE_SEND_SMS_EMAIL_INTERVIEW_CALL_LETTER_LINK
} from 'constants/constants';

const { Sider } = Layout;
const { SubMenu, ItemGroup } = Menu;

const SIDEBAR_COLLAPSED_KEY = 'ADMIN_SIDEBAR_COLLAPSED';

// Sprint 2.6.3 (Enterprise Operations Console): reorganizes the ~50 links previously spread across
// AdminHeader.jsx's 13 flat horizontal dropdowns into 9 logical groups. Every route/path/leaf label is
// unchanged — only the container. Full mapping rationale in S2_6_3_Navigation_Register.md.
const NAV_GROUPS = [
  {
    key: 'dashboard', icon: 'dashboard', label: 'Dashboard',
    items: [
      { key: 'dashboard', label: 'Dashboard', path: routesAdmin.dashboard.path }
    ]
  },
  {
    key: 'registration', icon: 'form', label: 'Registration',
    items: [
      { key: 'post', label: 'Post/Exam', path: routesAdmin.post.path },
      { key: 'postconfiguration', label: 'Post/Exam Config', path: routesAdmin.postconfiguration.basePath }
    ]
  },
  {
    // UTKARSHAN Admin Dashboard Iteration (§4): 17 items in one flat list was the reported problem
    // ("Candidate Menu has a lot of Submenus - We should categorize those"). Regrouped into 5
    // sub-categories following the actual recruitment lifecycle this app itself uses (the same stage
    // vocabulary as everywhere else in this project — Eligible List → Answer Key → Result → Interview
    // → Appointment), not an arbitrary split. Every key/label/path below is byte-for-byte unchanged
    // from the flat list — this is a presentation regrouping only, no routes/permissions/behavior
    // changed. `findActiveKeys`/the render loop (below) were extended to understand `subgroups`
    // generically; every other NAV_GROUPS entry still uses the original flat `items` shape untouched.
    key: 'candidates', icon: 'team', label: 'Candidates',
    subgroups: [
      {
        key: 'candidates-management', label: 'Candidate Management',
        items: [
          { key: 'candidateslist', label: 'Candidates List', path: routesAdmin.candidateslist.path },
          { key: 'viewCandidateInfo', label: 'Candidate Info', path: routesAdmin.viewCandidateInfo.path }
        ]
      },
      {
        key: 'candidates-hallticket', label: 'Hall Ticket & Center',
        items: [
          { key: 'viewExamCardByAdmin', label: 'View Hall Ticket', path: routesAdmin.viewExamCardByAdmin.path },
          { key: 'assigncenter', label: 'Assign Center', path: routesAdmin.assigncenter.path },
          { key: 'generaterollnumbers', label: 'Generate Roll Numbers', path: routesAdmin.generaterollnumbers.path }
        ]
      },
      {
        key: 'candidates-result', label: 'Result & Answer Key',
        items: [
          { key: 'eligiblecandidatelist', label: 'Eligible Candidate List', path: routesAdmin.eligiblecandidatelist.path },
          { key: 'answerkey', label: 'Answer Key', path: routesAdmin.answerkey.path },
          { key: 'answerkeyobjection', label: 'Answer Key Objections', path: routesAdmin.answerkeyobjection.path },
          { key: 'uploadResult', label: 'Upload Result', path: routesAdmin.uploadResult.path },
          { key: 'finalresult', label: 'Final Result', path: routesAdmin.finalresult.path }
        ]
      },
      {
        key: 'candidates-interview', label: 'Interview',
        items: [
          { key: 'interviewshortlist', label: 'Interview Shortlist', path: routesAdmin.interviewshortlist.path },
          { key: 'interviewschedule', label: 'Interview Scheduling', path: routesAdmin.interviewschedule.path },
          { key: 'uploadStudentInterviewTimeData', label: 'Upload Candidate Interview Time Data', path: routesAdmin.uploadStudentInterviewTimeData.path },
          { key: 'viewStudentInterviewTimeData', label: 'View Candidate Interview Time Data', path: routesAdmin.viewStudentInterviewTimeData.path },
          { key: 'uploadInterviewResult', label: 'Upload Interview Result', path: routesAdmin.uploadInterviewResult.path }
        ]
      },
      {
        key: 'candidates-appointment', label: 'Appointment',
        items: [
          { key: 'uploadStudentAppointmentData', label: 'Upload Candidate Appointment Data', path: routesAdmin.uploadStudentAppointmentData.path },
          { key: 'viewStudentAppointmentData', label: 'View Candidate Appointment Data', path: routesAdmin.viewStudentAppointmentData.path }
        ]
      }
    ]
  },
  {
    key: 'transactions', icon: 'wallet', label: 'Transactions',
    items: [
      { key: 'banktransactions', label: 'Import Challan Transactions', path: routesAdmin.banktransactions.path },
      { key: 'transactionsList', label: 'Online Transactions', path: routesAdmin.transactionsList.path }
    ]
  },
  {
    key: 'attendance', icon: 'calendar', label: 'Attendance',
    items: [
      { key: 'newattendancesheet', label: 'Attendance', path: routesAdmin.newattendancesheet.path },
      { key: 'uploadCenterBatchData', label: 'Upload Center Batch Data', path: routesAdmin.uploadCenterBatchData.path },
      { key: 'viewCenterBatchData', label: 'View Center Batch Data', path: routesAdmin.viewCenterBatchData.path },
      { key: 'uploadCenterBatchLabCountData', label: 'Upload Center Batch Lab Count Data', path: routesAdmin.uploadCenterBatchLabCountData.path },
      { key: 'viewCenterBatchLabCountData', label: 'View Center Batch Lab Count Data', path: routesAdmin.viewCenterBatchLabCountData.path },
      { key: 'uploadAttendance', label: 'Upload attendance', path: routesAdmin.uploadAttendance.path },
      { key: 'generateatendance', label: 'Generate attendance', path: routesAdmin.generateatendance.path }
    ]
  },
  {
    key: 'masters', icon: 'appstore', label: 'Masters',
    items: [
      { key: 'challanbankdetails', label: 'Challan Details', path: routesAdmin.challanbankdetails.path },
      { key: 'degree', label: 'Degree', path: routesAdmin.degree.path },
      { key: 'specialization', label: 'Specialization', path: routesAdmin.specialization.path },
      { key: 'university', label: 'University', path: routesAdmin.university.path },
      { key: 'category', label: 'Category', path: routesAdmin.category.path },
      { key: 'center', label: 'Center', path: routesAdmin.center.path },
      { key: 'batch', label: 'Batch', path: routesAdmin.batch.path },
      { key: 'questionAnswer', label: 'Question Answer', path: routesAdmin.questionAnswer.path },
      { key: 'akshepData', label: 'Aakshep Data', path: routesAdmin.akshepData.path }
    ]
  },
  {
    key: 'reports', icon: 'file-text', label: 'Reports',
    items: [
      { key: 'exportcandidates', label: 'Export Candidates', path: routesAdmin.exportcandidates.path },
      { key: 'exportattendance', label: 'Approved Candidate Data', path: routesAdmin.exportattendance.path },
      { key: 'exportPhotoSignature', label: 'Export Photo & Signature', path: routesAdmin.exportPhotoSignature.path },
      { key: 'exportCenterWiseAttendanceData', label: 'Export Center Wise Attendance Data', path: routesAdmin.exportCenterWiseAttendanceData.path }
    ]
  },
  {
    key: 'communications', icon: 'message', label: 'Communications',
    items: [
      { key: 'sendBulkHallTicketSMS', label: 'Send Bulk Hall Ticket SMS', path: routesAdmin.sendBulkHallTicketSMS.path, disableGuard: DISABLE_SEND_SMS_EMAIL_HALL_TICKET_LINK },
      { key: 'retryHallTicketSMS', label: 'Send Retry Hall Ticket SMS', path: routesAdmin.retryHallTicketSMS.path, disableGuard: DISABLE_SEND_SMS_EMAIL_HALL_TICKET_LINK },
      { key: 'sendBulkHallTicketEmail', label: 'Send Bulk Hall Ticket Email', path: routesAdmin.sendBulkHallTicketEmail.path, disableGuard: DISABLE_SEND_SMS_EMAIL_HALL_TICKET_LINK },
      { key: 'retryHallTicketEmail', label: 'Send Retry Hall Ticket Email', path: routesAdmin.retryHallTicketEmail.path, disableGuard: DISABLE_SEND_SMS_EMAIL_HALL_TICKET_LINK },
      { key: 'sendBulkSMSForInterviewCallLetterDownload', label: 'Send Bulk Interview Call Letter SMS', path: routesAdmin.sendBulkSMSForInterviewCallLetterDownload.path, disableGuard: DISABLE_SEND_SMS_EMAIL_INTERVIEW_CALL_LETTER_LINK },
      { key: 'retryInterviewCallLetterDownloadSMS', label: 'Send Retry Interview Call Letter SMS', path: routesAdmin.retryInterviewCallLetterDownloadSMS.path, disableGuard: DISABLE_SEND_SMS_EMAIL_INTERVIEW_CALL_LETTER_LINK },
      { key: 'sendBulkEmailForInterviewCallLetterDownload', label: 'Send Bulk Interview Call Letter Email', path: routesAdmin.sendBulkEmailForInterviewCallLetterDownload.path, disableGuard: DISABLE_SEND_SMS_EMAIL_INTERVIEW_CALL_LETTER_LINK },
      { key: 'retryEmailForInterviewCallLetterDownload', label: 'Send Retry Interview Call Letter Email', path: routesAdmin.retryEmailForInterviewCallLetterDownload.path, disableGuard: DISABLE_SEND_SMS_EMAIL_INTERVIEW_CALL_LETTER_LINK },
      { key: 'sendBulkViewResultSMS', label: 'Send View Result SMS', path: routesAdmin.sendBulkViewResultSMS.path },
      { key: 'sendBulkViewResultEmail', label: 'Send View Result Email', path: routesAdmin.sendBulkViewResultEmail.path }
    ]
  },
  {
    key: 'enterprise', icon: 'global', label: 'Enterprise',
    items: [
      { key: 'enterpriseconfig', label: 'Enterprise Configuration', path: routesAdmin.enterpriseconfig.path },
      { key: 'languageconfiguration', label: 'Language Configuration', path: routesAdmin.languageconfiguration.path },
      { key: 'paymentgatewayconfiguration', label: 'Payment Gateway Configuration', path: routesAdmin.paymentgatewayconfiguration.path },
      { key: 'governance', label: 'Governance', path: routesAdmin.governance.path },
      { key: 'compliancecenter', label: 'Compliance Center', path: routesAdmin.compliancecenter.path }
    ]
  },
  {
    key: 'settings', icon: 'setting', label: 'Settings',
    items: [
      { key: 'license', label: 'License Key', path: routesAdmin.license.path },
      { key: 'portalconfiguration', label: 'Portal Config', path: routesAdmin.portalconfiguration.path },
      { key: 'publication', label: 'Publications', path: routesAdmin.publication.path }
    ]
  }
];

// Collapsed-Sidebar Flyout Position phase (28 Aug 2026) — real defect fix: `subgroups` used to render
// as a 3rd level of nested antd `SubMenu` (group SubMenu -> subgroup SubMenu -> item). antd 3.x's
// rc-menu hardcodes a nested SubMenu's popup container to its trigger's own `parentNode` whenever the
// SubMenu's parent is another SubMenu (rather than the root Menu) — with NO app-level prop able to
// override it (confirmed against rc-menu's source). That parent is itself an absolutely-positioned
// flyout, so the nested popup's page-absolute coordinates resolved against the WRONG containing block,
// rendering it floating and disconnected from the hovered icon — reproducible only for the
// `candidates` group, the sole NAV_GROUPS entry using `subgroups`. Fixed by rendering each subgroup as
// a `Menu.ItemGroup` (a static label/divider, not a popup-producing SubMenu) instead — this removes the
// 3rd SubMenu level entirely, so the flyout is root-parented again like every other group and
// correctly resolves to `document.body`. `sub.key` is therefore no longer a real openable Menu key;
// `openKeys` only ever needs the top-level `group.key`.
const findActiveKeys = (pathname) => {
  for (const group of NAV_GROUPS) {
    if (group.subgroups) {
      for (const sub of group.subgroups) {
        const match = sub.items.find(item => item.path === pathname);
        if (match) {
          return { openKeys: [group.key], selectedKey: match.key };
        }
      }
    } else {
      const match = group.items.find(item => item.path === pathname);
      if (match) {
        return { openKeys: [group.key], selectedKey: match.key };
      }
    }
  }
  return { openKeys: [], selectedKey: null };
};

class AdminSidebar extends Component {
  constructor(props) {
    super(props);
    const stored = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    this.state = {
      collapsed: stored === 'true',
      openKeys: []
    };
  }

  componentDidMount() {
    const { openKeys } = findActiveKeys(this.props.location.pathname);
    if (openKeys.length) {
      this.setState({ openKeys });
    }
  }

  toggleCollapsed = () => {
    this.setState((prev) => {
      const collapsed = !prev.collapsed;
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed));
      return { collapsed };
    });
  };

  // Collapsed-Sidebar Flyout Position phase: back to the original flat "one top-level group open at
  // a time" accordion behavior — subgroups are now `Menu.ItemGroup`s (see findActiveKeys above), not
  // separate openable SubMenus, so there is no longer a second level here to keep in sync with its
  // parent.
  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    this.setState({ openKeys: latestOpenKey ? [latestOpenKey] : [] });
  };

  render() {
    const { collapsed, openKeys } = this.state;
    const { selectedKey } = findActiveKeys(this.props.location.pathname);

    return (
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={this.toggleCollapsed}
        // UTKARSHAN Admin Dashboard Iteration (§6): 260→280px. The Candidates group's new 3-level
        // nesting (group → subgroup → item, §4) pushes items further right than the old flat 2-level
        // structure did, shrinking the text column further at the old width — a contributing cause of
        // clipped labels, not just missing ellipsis handling.
        width={280}
        className="ent-admin-sidebar"
      >
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKey ? [selectedKey] : []}
          openKeys={openKeys}
          onOpenChange={this.onOpenChange}
          // Quick fix: when the sidebar is collapsed, antd renders a group's items as a single
          // hover-triggered flyout popup instead of inline expansion — antd's default
          // subMenuCloseDelay (0.1s) closed that flyout the instant the cursor left its trigger,
          // before the mouse could actually reach the popup — reported as menus "closing rapidly"
          // and feeling unstable. subMenuOpenDelay left slightly above 0 too, so opening feels
          // equally deliberate rather than opening instantly but closing sluggishly by comparison
          // (a mismatched, jumpy feel).
          subMenuOpenDelay={0.15}
          subMenuCloseDelay={0.3}
        >
          {NAV_GROUPS.map(group => (
            <SubMenu key={group.key} title={<span><Icon type={group.icon} /><span title={group.label}>{group.label}</span></span>}>
              {group.subgroups
                ? group.subgroups.map(sub => (
                    <ItemGroup key={sub.key} title={<span title={sub.label}>{sub.label}</span>}>
                      {sub.items.map(item => (
                        <Menu.Item key={item.key}>
                          <NavLink
                            to={item.path}
                            title={item.label}
                            onClick={item.disableGuard ? (e) => e.preventDefault() : undefined}
                          >
                            {item.label}
                          </NavLink>
                        </Menu.Item>
                      ))}
                    </ItemGroup>
                  ))
                : group.items.map(item => (
                    <Menu.Item key={item.key}>
                      <NavLink
                        to={item.path}
                        title={item.label}
                        onClick={item.disableGuard ? (e) => e.preventDefault() : undefined}
                      >
                        {item.label}
                      </NavLink>
                    </Menu.Item>
                  ))
              }
            </SubMenu>
          ))}
        </Menu>
      </Sider>
    );
  }
}

export default withRouter(AdminSidebar);
